export default {
      id: "heart-usage",
      viewBox: "0 0 40 40",
      url: __webpack_public_path__ + "img/icons.4f7c228b.svg#heart",
      toString: function () {
        return this.url;
      }
    }